import { render, staticRenderFns } from "./areaMap.vue?vue&type=template&id=6ca4827e&scoped=true&"
import script from "./areaMap.vue?vue&type=script&lang=js&"
export * from "./areaMap.vue?vue&type=script&lang=js&"
import style0 from "./areaMap.vue?vue&type=style&index=0&id=6ca4827e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4827e",
  null
  
)

export default component.exports